module.exports = __webpack_public_path__ + "static/Rheinhessen2-scaled-ffcc89b14618562c7551f6d87d228e44.jpeg";